
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ocean-pro-home-solar-battery/faq",
      function () {
        return require("private-next-pages/ocean-pro-home-solar-battery/faq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ocean-pro-home-solar-battery/faq"])
      });
    }
  